import api from "./apiService";

export const getLanguages = () => api().get(`/languageMaster/`).then(response => response);

const services = {
    getLanguages
}


export default services;